import React from 'react';
import { CheckCircle, MessageSquare } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { contact } from '../i18n/strings';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="legal" className="py-24 bg-[#09070f] border-t border-border-dark/60">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[0.95fr_1.05fr] gap-10 items-stretch">
          <div className="rounded-[2rem] bg-gradient-to-br from-primary via-pink to-accent p-1 shadow-glow">
            <div className="h-full rounded-[1.85rem] bg-dark/90 p-8 lg:p-10 flex flex-col justify-center">
              <span className="text-accent text-sm font-bold uppercase tracking-[0.2em]">{t.about.kicker}</span>
              <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-white font-heading">
                {t.about.title}
              </h2>
              <p className="mt-5 text-slate-300 leading-relaxed">{t.about.intro}</p>
              <div className="mt-8 rounded-2xl bg-card-dark border border-border-dark p-5">
                <div className="flex items-start gap-3">
                  <MessageSquare className="w-6 h-6 text-primary-light shrink-0 mt-1" />
                  <p className="text-white font-semibold leading-relaxed">{t.about.activation}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-card-dark border border-border-dark rounded-[2rem] p-8 lg:p-10">
            <div className="grid sm:grid-cols-3 gap-4 mb-8">
              <div className="rounded-2xl bg-dark border border-border-dark p-5">
                <p className="text-slate-500 text-xs uppercase tracking-widest">SMS</p>
                <p className="mt-2 text-white font-extrabold text-2xl">{contact.smsKeyword}</p>
              </div>
              <div className="rounded-2xl bg-dark border border-border-dark p-5">
                <p className="text-slate-500 text-xs uppercase tracking-widest">Number</p>
                <p className="mt-2 text-white font-extrabold text-2xl">{contact.shortcode}</p>
              </div>
              <div className="rounded-2xl bg-dark border border-border-dark p-5">
                <p className="text-slate-500 text-xs uppercase tracking-widest">Stop</p>
                <p className="mt-2 text-white font-extrabold text-2xl">{contact.stopKeyword}</p>
              </div>
            </div>

            <div className="space-y-5">
              {t.about.paragraphs.map((line) => (
                <div key={line} className="flex gap-3 items-start">
                  <CheckCircle className="w-5 h-5 text-primary-light shrink-0 mt-0.5" />
                  <p className="text-slate-400 leading-relaxed">{line}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
